export const UNIT_OPTIONS = [
  { label: 'mg (milligram)', value: 'mg' },
  { label: 'g (gram)', value: 'g' },
  { label: 'mcg (microgram)', value: 'mcg' },
  { label: 'mL (milliliter)', value: 'mL' },
  { label: 'tablet', value: 'tablet' },
  { label: 'capsule', value: 'capsule' },
  { label: 'patch', value: 'patch' },
  { label: 'puff', value: 'puff' },
  { label: 'drop', value: 'drop' },
  { label: 'unit', value: 'unit' },
  { label: 'spray', value: 'spray' },
] as const;

export type UnitOption = (typeof UNIT_OPTIONS)[number];
export type UnitValue = UnitOption['value'];
export const ROUTE_OPTIONS = [
  { label: 'Oral (PO)', value: 'Oral (PO)' },
  { label: 'Intravenous (IV)', value: 'Intravenous (IV)' },
  { label: 'Intramuscular (IM)', value: 'Intramuscular (IM)' },
  { label: 'Subcutaneous (SC)', value: 'Subcutaneous (SC)' },
  { label: 'Transdermal (Topical)', value: 'Transdermal (Topical)' },
  { label: 'Inhalation', value: 'Inhalation' },
  { label: 'Sublingual', value: 'Sublingual' },
  { label: 'Rectal', value: 'Rectal' },
  { label: 'Nasal', value: 'Nasal' },
  { label: 'Ophthalmic', value: 'Ophthalmic' },
  { label: 'Otic', value: 'Otic' },
] as const;

export type RouteOption = (typeof ROUTE_OPTIONS)[number];
export type RouteValue = RouteOption['value'];
export const FREQUENCY_OPTIONS = [
  { label: 'Once daily (QD)', value: 'Once daily (QD)' },
  { label: 'Twice daily (BID)', value: 'Twice daily (BID)' },
  { label: 'Three times daily (TID)', value: 'Three times daily (TID)' },
  { label: 'Four times daily (QID)', value: 'Four times daily (QID)' },
  { label: 'Every 4 hours (Q4H)', value: 'Every 4 hours (Q4H)' },
  { label: 'Every 6 hours (Q6H)', value: 'Every 6 hours (Q6H)' },
  { label: 'Every 8 hours (Q8H)', value: 'Every 8 hours (Q8H)' },
  { label: 'Every 12 hours (Q12H)', value: 'Every 12 hours (Q12H)' },
  { label: 'As needed (PRN)', value: 'As needed (PRN)' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
] as const;

export type FrequencyOption = (typeof FREQUENCY_OPTIONS)[number];
export type FrequencyValue = FrequencyOption['value'];
